/**
 * Horizontal App
 */
import React, { Component } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

// app default layout
import MainLayout from 'Components/MainLayout';

// router service
import routerService from '../services/_routerService';

class MainContainer extends Component {
  render() {
    return (
      <MainLayout>
        <Routes>
          {routerService && routerService.map((route, key) => <Route key={key} path={`${route.path}`} element={<route.component />} />)}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </MainLayout>
    );
  }
}

export default MainContainer;
